import React from 'react';
import { Button, Col, FormGroup, Input, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import DeleteButton from 'components/buttons/DeleteButton';

const formatDateForInput = (value) => {
    if (!value) return '';
    return String(value).substring(0, 10);
};

const SkipDaysInput = ({ value = [], onChange, readOnly = false }) => {
    const skipDays = Array.isArray(value) ? value : [];

    const updateDays = (nextDays) => {
        onChange({ target: { value: nextDays } });
    };

    const handleDayChange = (index, dateValue) => {
        const nextDays = [...skipDays];
        nextDays[index] = dateValue;
        updateDays(nextDays);
    };

    const handleAdd = () => {
        updateDays([...skipDays, '']);
    };

    const handleRemove = (index) => {
        const nextDays = [...skipDays];
        nextDays.splice(index, 1);
        updateDays(nextDays);
    };

    return (
        <div className="scheduler-skip-days">
            {skipDays.map((day, index) => (
                <FormGroup key={`${index}-${day}`}>
                    <Row className="align-items-center">
                        <Col md={10}>
                            <Input
                                type="date"
                                value={formatDateForInput(day)}
                                onChange={(event) => handleDayChange(index, event.target.value)}
                                readOnly={readOnly}
                                style={{ maxWidth: '13em' }}
                            />
                        </Col>
                        <Col md={2}>
                            {!readOnly && <DeleteButton deleteItem={handleRemove} id={index} />}
                        </Col>
                    </Row>
                </FormGroup>
            ))}
            {!readOnly && (
                <Button color="secondary" size="sm" onClick={handleAdd}>
                    <FontAwesomeIcon icon={faPlus} className="me-1" />
                </Button>
            )}
        </div>
    );
};

export default SkipDaysInput;
